export interface EmailRequest {
  recipient: string[];
  subject: string;
  content: string;
}

export interface AuditTrail {
  action: string;
  actionDate: string;
  operatorId: string;
  description: string;
}

export interface AdditionalField {
  key: string;
  value: string | boolean;
  label: string;
  displayOrder: number;
  bloc: number;
}

export interface TerminationRequest {
  customerStatus: string;
  collaboratorStatus: string;
  brand: string;
  beneficiaryType: number;
  isToReview: boolean;
  applicantId: string;
  reviewDate: string;
  responsibleCollaboratorId: string;
  collaboratorFullName: string;
  responsibleType: number;
  creationDate: string;
  treatmentEndDate: string;
  media: string;
  applicant: string;
  origin: string;
  channel: string;
  reason: { functionalCode: string };
  auditTrails: AuditTrail[];
  state: { id: number };
  family: { domain: string };
  creator: string;
  additionnalFields: AdditionalField[];
}
export enum ContentKeys {
  date = 'Date et heure d_emission',
  sender = 'Emetteur',
  formName = 'Nom du formulaire',
  idendity = 'Identite du titulaire',
  ikpi = 'IKPI',
  telematicId = 'Id telematique',
  civility = 'Civilite',
  lastName = 'Nom',
  firstName = 'Prenom',
  companyName = 'Raison sociale',
  requestorLastName = 'Nom du demandeur',
  requestorFirstName = 'Prenom du demandeur',
  birthDate = 'Date de naissance',
  birthCountry = 'Pays de naissance',
  birthPlace = 'Commune de naissance',
  canalType = 'Type de canal',
  clientMailAdress = 'Adresse email client',
  clientPostalAdress = 'Adresse postale client',
  contractType = 'Type de contrat',
  terminationType = 'Type de demande',
  product = 'Produit a resilier',
  productConcerned = 'Produit concerné par la demande',
  request = 'Votre demande',
  contractName = 'Nom contrat',
  contractNumber = 'Numero de contrat',
  desiredTerminationDate = 'Date resiliation souhaite',
  terminationReason = 'Motif resiliation',
  otherTerminationReasons = 'Autre motif resiliation',
}

export const TerminationRequestValues = {
  empty: '',
  supported: 'Pris en charge',
  brand: 'BNPP',
  notSpecified: 'Non renseigné',
  client: 'Client',
  action: 'Création',
  operatorId: 'Site internet Ma Banque',
  description: 'Créer Demande',
  domain: 'RETAIL',
  creator: 'Client BNPP',
} as const;

export const AdditionnalFieldsKeys = {
  NOM_DEMANDEUR: 'NOM_DEMANDEUR',
  PRENOM_DEMANDEUR: 'PRENOM_DEMANDEUR',
  INDICATEUR_AR_MAIL: 'INDICATEUR_AR_MAIL',
  CLIENT_ADRESSE_MAIL: 'CLIENT_ADRESSE_MAIL',
  INDICATEUR_AR_PAPIER: 'INDICATEUR_AR_PAPIER',
  ADRESSE: 'ADRESSE',
  CODE_POSTAL: 'CODE_POSTAL',
  VILLE: 'VILLE',
  TYPE_CONTRAT: 'TYPE_CONTRAT',
  TYPE_DEMANDE: 'TYPE_DEMANDE',
  NOM_CONTRAT: 'NOM_CONTRAT',
  NUMERO_CONTRAT: 'NUMERO_CONTRAT',
  INDICATEUR_PRODUIT_ADE: 'INDICATEUR_PRODUIT_ADE',
  DATE_RESILIATION_SOUHAITEE: 'DATE_RESILIATION_SOUHAITEE',
  MOTIF_RESILIATION: 'MOTIF_RESILIATION',
  AUTRE_MOTIF: 'AUTRE_MOTIF',
} as const;

export const AdditionnalFieldsLabels = {
  NOM_DEMANDEUR: 'Nom du demandeur',
  PRENOM_DEMANDEUR: 'Prenom du demandeur',
  INDICATEUR_AR_MAIL: 'Indicateur AR mail',
  CLIENT_ADRESSE_MAIL: 'Adresse email pour AR mail',
  INDICATEUR_AR_PAPIER: 'Indicateur AR papier',
  ADRESSE: 'Adresse postale',
  CODE_POSTAL: 'Code Postal',
  VILLE: 'Ville',
  TYPE_CONTRAT: 'Type de contrat',
  TYPE_DEMANDE: 'Type de demande',
  NOM_CONTRAT: 'Contrat à résilier / Nom contrat',
  NUMERO_CONTRAT: 'Numéro du contrat',
  INDICATEUR_PRODUIT_ADE: 'Produit ADE',
  DATE_RESILIATION_SOUHAITEE: 'Date de résiliation souhaitée',
  MOTIF_RESILIATION: 'Motif de résiliation',
  AUTRE_MOTIF: 'Autre Motif',
} as const;
